import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { LeftAlignedTitle } from "@components/LeftAlignedTitle";
import { NewsCard } from "@components/NewsCard";
import Pager from "@components/Pager";
import { Text } from "@components/Text";
import { usePagination } from "@hooks/usePagination";
import { usePagesNews_NewsArticlesQuery as useNewsArticlesQuery } from "./__generated__/queries";
import styles from "./index.module.css";
import type { NextPage } from "next";

const PER_PAGE = 10;

const TeamAllNewsArticles: NextPage = () => {
  const { currentPage, navigate } = usePagination();
  const { data, loading, error } = useNewsArticlesQuery({
    variables: {
      page: currentPage,
      perPage: PER_PAGE,
    },
    onError: (error) => {
      console.error(error);
    },
  });
  const isReady = !loading && !error;
  const newsArticles = data?.newsArticles.nodes;

  const pagination = data?.newsArticles
    ? {
        hasPreviousPage: data.newsArticles.hasPreviousPage,
        hasNextPage: data.newsArticles.hasNextPage,
        totalPage: data.newsArticles.totalPage,
        currentPage,
      }
    : {};

  return (
    <CommonLayout>
      <CommonHead
        title="Fanstaのニュース一覧"
        description={
          "Fanstaのニュース一覧です。スポーツ観戦がもっと楽しくなるイベント情報や、おトクなキャンペーンのお知らせをご紹介。スポーツバー探し、予約はFanstaで。"
        }
        ogType={"website"}
      />

      <div className={styles.teamNewsWrapper}>
        <div className={styles.teamNewsContentWidth}>
          <LeftAlignedTitle label="ニュース" />

          {isReady && newsArticles && (
            <>
              {newsArticles.length === 0 ? (
                <div className={styles.notfound}>
                  <Text size={16}>ニュースはありません</Text>
                </div>
              ) : (
                <>
                  <div className={styles.articlesList}>
                    {newsArticles?.map((n) => (
                      <NewsCard newsArticle={n} key={n.id} />
                    ))}
                  </div>
                  <Pager {...pagination} onNavigation={navigate} />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </CommonLayout>
  );
};

export default TeamAllNewsArticles;
